import { Component } from '@angular/core';

@Component({
  selector: 'app-title',
  standalone: false,
  
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {

}
